.nudge-input-animated {
    display: flex;
    align-items: center;
    gap: 4px;
    background-color: white;
    height: 60px;
    width: 242px;
    border-radius: 8px;
    padding-left: 8px;
    position: relative;
    z-index: 0;
}

.nudge-input-animated::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 8px;
    padding: 1.25px;
    background: linear-gradient(
        90deg,
        #d1d5db,
        #d1d5db,
        #d1d5db,
        var(--appearance-color, #6366f1),
        #d1d5db,
        #d1d5db,
        #d1d5db
    );
    background-size: 400% 100%;
    animation: animatedBorder 5s ease-in-out infinite;
    z-index: -1;
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
    box-sizing: border-box;
}

@keyframes animatedBorder {
    0% {
        background-position: 100% 50%;
    }
    50% {
        background-position: 0% 50%;
    }
    100% {
        background-position: 100% 50%;
    }
}
